import BookingForm from "../../components/BookingForm";
import "./booking.scss";

const Booking = () => {
  return (
    <>
      <div className="header-banner-booking"></div>

      <BookingForm />
    </>
  );
};

export default Booking;
